import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import Button from 'grommet/components/Button';
import GrRackServerPresentation from './GrRackServerPresentation';
import Revert from 'grommet/components/icons/base/Revert';
import GrRackServerInnerPresentation from'./GrRackServerInnerPresentation';
import BOMGRpresentation from'./BOMGRpresentation';
/*Added by Vinay*/
import { said } from '../../AppConfig';

class GraphicalRepresentation extends Component{
  constructor(){
     super();
     this.state={
        GrConditionalView:true,
        ActiveSitedata:'',
        isPageLoading: true
     }  
     this.RackView=this.RackView.bind(this);
     this.ReverttoRackview=this.ReverttoRackview.bind(this);
     this.onBomChange=this.onBomChange.bind(this);
  }
  onBomChange(){
      
  }
componentWillMount(){
     
 }
  RackView(e,a){
  //   console.log(a);
     this.setState({GrConditionalView:e,ActiveSitedata:a});
  }

  ReverttoRackview(e){
      this.setState({GrConditionalView:e});
  }

  updateLoadingValue = () => {
    setTimeout(() => {
      this.setState({ isPageLoading: false });
    }, 3000);
  }

  render(){
    let  BOMDisplay;
    let guidanceid = this.props.externalAppProps.guidanceid;
    let solutionTitle = 'Solution Layout';
    if(guidanceid!==null || guidanceid!==undefined)
       solutionTitle = 'Solution Layout'+' - GuidanceID : '+guidanceid;
    /*Changes by Vinay, checking said === 'CS750VirtSizer' condition to hide GRBOM for CS750 Sizing.*/
     if(this.props.listItem || said === 'CS750VirtSizer'){
         BOMDisplay =  ''
     }else{
           if (! this.props.isFromExternalApp) {
        	   BOMDisplay =  <Tab title='BOM' >
                        <Box direction='row' margin="none" pad="none"  className="GrTabInnerSection" justify='start' align='center'style={{height:'100%',width:'100%'}}>
                            <BOMGRpresentation actvSoln={this.props.actvSoln} />                            
                        </Box>
                     </Tab>
           }
     }

      return(
       <Box className="GRPResentPage GRPageLayoutsink" direction='row' margin="none" pad="small"  justify='start'   style={{width:'100% !import',height:'100%', marginTop:'0px'}}>
        
     
         <Tabs justify='start'  style={{width:'100%'}}>
           <Tab title=  {solutionTitle} >
          <Box direction='row' margin="none" pad="none"  className="GrTabInnerSection" justify='start' align='center'style={{height:'100%',width:'100%!import'}}>
                  {this.state.GrConditionalView ? <GrRackServerPresentation externalAppProps={this.props.externalAppProps} isFromExternalApp={this.props.isFromExternalApp} actvSoln={this.props.actvSoln} StaticGRlist={this.props.listItem} RackserverView1={this.RackView} isPageLoading={this.updateLoadingValue}/> :<GrRackServerInnerPresentation externalAppProps={this.props.externalAppProps} isFromExternalApp={this.props.isFromExternalApp} RackserverView={this.ReverttoRackview} PassActiveSite={this.state.ActiveSitedata} actvSoln={this.props.actvSoln}/>}    
                </Box>
           </Tab>
            {BOMDisplay}    
         </Tabs>
         {this.props.isFromExternalApp && !this.state.isPageLoading ?  <Button id="backToSSETyes" primary={false} plain={true} style={{position:'absolute',right:'0',color:'white'}}  /* icon={<Revert size="small" colorIndex='accent-3' />} */ label='Close' onClick={()=>window.location.replace(this.props.externalAppProps.ssetUrl)} className="ReverseSavewrkloadbtn" />  : ''}
       </Box>
      );
  }
}

export default GraphicalRepresentation;



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/GraphicalRepresentation.js